import useAPI from "./useAPI";
import useCompany from "./useCompany";

export default function useTokens() {
  const api = useAPI();
  const { activeCompany: company } = useCompany();

  const createToken = async (tokenData) => {
    if (!company) throw new Error("No active company");
    return await api.createCompanyToken(company.id, tokenData);
  }
  
  const updateToken = async (tokenId, tokenData) => {
    if (!company) throw new Error("No active company");
    return await api.updateCompanyToken(company.id, tokenId, tokenData);
  }

  const getToken = async (tokenId) => {
    if (!company) throw new Error("No active company");
    return await api.getCompanyToken(company.id, tokenId);
  }

  const deleteToken = async (tokenId) => {
    if (!company) throw new Error("No active company");
    return await api.deleteCompanyToken(company.id, tokenId);
  }

  const generateContract = async ({ prompt, name, contractType, sourceCode } = {}) => {
    if (!company) throw new Error("No active company");
    return await api.generateCompanySmartContract(company.id, { prompt, name, contractType, sourceCode });
  }

  return {
    createToken,
    updateToken,
    getToken,
    deleteToken,
    generateContract,
  }
}
